import { useContext } from "react";
import { LabelsContext } from "../../BookingButton/LabelsContext/LabelsContext";

export const useLabels = () => {
	const context = useContext(LabelsContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
};
